import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AdministrationCompanyState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AdministrationCompanyState = {
  data: [],
  isLoading: false,
  error: null,
};

const companySlice = createSlice({
  name: 'administrationCompanies',
  initialState,
  reducers: {
    setAdministrationCompanies: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAdministrationCompanyLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAdministrationCompanyError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setAdministrationCompanies, setAdministrationCompanyLoading, setAdministrationCompanyError } =
  companySlice.actions;

export default companySlice.reducer;
